import { IGfpaSummaryDTO } from '@/interfaces/gfpaReport.interface'
import { defaultColDefs } from '@/utils/grid-utils/colDefs'
import { getUpdatedColumnsWithTooltip } from '@/utils/tableGridUtils'
import { GridReadyEvent, ModuleRegistry } from '@ag-grid-community/core'
import { CsvExportModule } from '@ag-grid-community/csv-export'
import { AgGridReact } from '@ag-grid-community/react'
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export'
import { GFPASummaryTableColumns } from '@components/GFPA/SummaryReport/ColumnDefs/GFPASummaryTableColumns'
import { sideBarDefaultConfig } from '@utils/grid-utils/ag-grid-config'
import React, { useCallback, useEffect, useRef } from 'react'

export type IGFPASummary = {
  rowData: IGfpaSummaryDTO[]
  setGridReference: Function
  reportType: string
}

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule])
export const GFPASummaryTable: React.FC<IGFPASummary> = ({
  rowData,
  setGridReference,
  reportType,
}) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const sizeToFit = useCallback(() => {
    const api = gridRef.current?.api
    if (api) {
      api.sizeColumnsToFit()
    }
  }, [])

  useEffect(() => {
    // Event listener for window resize
    window.addEventListener('resize', sizeToFit)

    // Cleanup
    return () => {
      window.removeEventListener('resize', sizeToFit)
    }
  }, [sizeToFit])

  const onGridReady = (params: GridReadyEvent) => {
    params.api.sizeColumnsToFit()
    setGridReference(gridRef)
  }

  return (
    <div className={`${themeClassName}`} style={{ height: '100%' }}>
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        defaultColDef={defaultColDefs}
        columnDefs={getUpdatedColumnsWithTooltip(
          GFPASummaryTableColumns,
          reportType,
        )}
        rowData={rowData}
        sideBar={sideBarDefaultConfig}
        data-cy='ag-grid'
      ></AgGridReact>
    </div>
  )
}
